import React, { useEffect } from "react";

import isEmpty from "lodash/isEmpty";
import { queryCache } from "react-query";

import { useGetManagerProfile } from "manager/hooks/api";
import { COMPANY_QUERY_KEYS } from "manager/hooks/api/companyQueries";
import { usePermissions } from "shared/hooks";
import {
  getCachedActiveCompanyId,
  getCachedActiveCompanySlug,
} from "shared/utils/auth";
import { useVeroFlag } from "shared/utils/featureFlags";
import { VeroFlag } from "shared/utils/veroFlags";

import Settings from "./Settings";

const SettingsContainer = () => {
  const {
    company,
    isLumenAdmin,
    isOpenApiEnabled,
    isPrescreeningEnabled,
    isVeroGoEnabled,
    permissionsLoaded,
  } = usePermissions();

  const { data: profile } = useGetManagerProfile({
    enabled: !isEmpty(company),
  });

  useEffect(() => {
    const cachedCompany = getCachedActiveCompanyId() || getCachedActiveCompanySlug();
    if (!cachedCompany) return;

    queryCache.refetchQueries(COMPANY_QUERY_KEYS.getCompany(cachedCompany));
  }, []);

  const veroCopilot = useVeroFlag(VeroFlag.veroCopilot);

  return (
    <Settings
      isDownloadCenterVisible={profile?.isDownloadCenterVisible}
      isLumenAdmin={isLumenAdmin}
      isOpenApiEnabled={isOpenApiEnabled}
      isPrescreeningEnabled={isPrescreeningEnabled}
      isCopilotEnabled={veroCopilot}
      isVeroGoEnabled={isVeroGoEnabled}
      loading={!permissionsLoaded}
    />
  );
};

export default SettingsContainer;
